export default __webpack_public_path__ + "static/media/online-pn-all-banner-secondary.7cac6e6a.png";